import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import PlanTrip from "../components/PlanTrip";
import AboutMain from "../images/about/abw.jpg";
import Box1 from "../images/about/icon1.png";
import Box2 from "../images/about/icon2.png";
import Box3 from "../images/about/icon3.png";

function About() {
  return (
    <>
      <section className="about-page">
        <HeroPages name="About" />
        <div className="container">
          <div className="about-main">
            <img
              className="about-main__img"
              src={AboutMain}
              alt="car-renting"
            />
            <div className="about-main__text">
              <h3 style={{fontFamily: 'Montserrat'}}>About Company</h3>
              <h2 style={{fontFamily: 'Montserrat'}}>You start the engine and your adventure begins</h2>
              <p style={{fontFamily: 'Montserrat'}}>
              Every journey begins with a simple tap—your ride, your way! With WakaForMe, enjoy seamless, reliable, and affordable rides at your fingertips. Whether you're heading to work, meeting friends, or exploring the city, we get you there safely and comfortably. No hassle, just the perfect ride when you need it.
              </p>
              {/* <div className="about-main__text__icons">
                <div className="about-main__text__icons__box">
                  <img src={Box1} alt="car-icon" />
                  <span>
                    <h4>10+</h4> <br />
                    <p>Car Types</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box2} alt="car-icon" />
                  <span>
                    <h4>10+</h4> <br />
                    <p>Osogbo & Environs</p>
                  </span>
                </div>
                <div className="about-main__text__icons__box">
                  <img src={Box3} alt="car-icon" className="last-fk" />
                  <span>
                    <h4>5000+</h4> <br />
                    <p>Customers</p>
                  </span>
                </div>
              </div> */}
            </div>
          </div>
          <PlanTrip />
        </div>
      </section>
      <div className="book-banner">
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2 style={{fontFamily:'Montserrat'}}>Book a Ride by getting in touch with us</h2>
            <span>
              <i className="fa-solid fa-phone" style={{color:'#f7931e'}}></i>
              <h4 style={{fontFamily:'Montserrat', color:'#f7931e'}}>(234) 801 619 2990</h4>
            </span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default About;
